<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

    <ng-container *ngIf="consulta">
        <div class="body">
            <ng-container *ngFor="let r of consulta?.registros; let i = index">
                <h2 class="subtitle subtitle-{{status}}">CONSULTA {{i+1}}</h2>
                <ul class="card-list-striped py-1">
                    <li>
                        <span class="text-secondary">DATA:</span>
                        <span class="text-uppercase text-center">{{ r?.data || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">TIPO:</span>
                        <span class="text-uppercase">{{ r?.tipo || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">INFORMANTE:</span>
                        <span class="text-uppercase">{{ r?.informante || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">DESCRIÇÃO:</span>
                        <span class="text-uppercase">{{ r?.descricao || msgNull }}</span>
                    </li>
                </ul>
            </ng-container>
        </div>
    </ng-container>

</app-card-consulta>